var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartsaNewIconMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 66,
    viewBox: "0 0 39 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 46.2156L15.6992 50.7336L18.8626 26.1258L0 46.2156Z",
    fill: "#0000DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6993 50.7336L38.9435 44.9884L18.8627 26.1258L15.6993 50.7336Z",
    fill: "url(#paint0_linear_1828_41)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6992 50.7336L20.0807 65.0783L0 46.2157L15.6992 50.7336Z",
    fill: "#0000C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6993 50.7337L38.9435 44.9885L20.0809 65.0784L15.6993 50.7337Z",
    fill: "url(#paint1_linear_1828_41)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5436 25.8714C34.38 26.8987 28.0167 26.7805 20.308 25.5987C12.5993 24.417 6.49054 22.6444 6.67235 21.6262C6.85416 20.6081 13.1993 20.7172 20.8989 21.8989C28.5984 23.0807 34.7345 24.8533 34.5436 25.8714Z",
    fill: "#C6062B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0084 46.8156C26.519 46.8156 32.6076 40.613 32.6076 32.9618C32.6076 25.3105 26.519 19.108 19.0084 19.108C11.4977 19.108 5.40909 25.3105 5.40909 32.9618C5.40909 40.613 11.4977 46.8156 19.0084 46.8156Z",
    fill: "url(#paint2_radial_1828_41)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6998 21.5716L34.5801 25.8168L24.6534 0L6.6998 21.5716Z",
    fill: "#C90D1F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09073 21.608L34.2075 25.735L24.6443 0.00912857L7.09073 21.608Z",
    fill: "#CB0F21"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4722 21.6442L33.8344 25.6622L24.6349 0.018136L7.4722 21.6442Z",
    fill: "#CD1122"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86365 21.6806L33.4532 25.5804L24.6264 0.0272646L7.86365 21.6806Z",
    fill: "#CF1424"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25388 21.7171L33.0798 25.4987L24.6166 0.0455217L8.25388 21.7171Z",
    fill: "#D11625"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64508 21.7535L32.7074 25.4169L24.6079 0.0546513L8.64508 21.7535Z",
    fill: "#D31827"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03577 21.7807L32.3345 25.335L24.5986 0.0636578L9.03577 21.7807Z",
    fill: "#D51A29"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42673 21.8171L31.9619 25.2533L24.5896 0.0727863L9.42673 21.8171Z",
    fill: "#D81C2A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80869 21.8534L31.5893 25.1714L24.5806 0.0817938L9.80869 21.8534Z",
    fill: "#DA1F2C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1996 21.8898L31.2167 25.0896L24.5716 0.0909224L10.1996 21.8898Z",
    fill: "#DC212E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5906 21.9261L30.8349 25.0077L24.5626 0.109058L10.5906 21.9261Z",
    fill: "#DE232F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9813 21.9534L30.4621 24.9259L24.5533 0.118187L10.9813 21.9534Z",
    fill: "#E02531"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3723 21.9898L30.0894 24.8442L24.5443 0.127316L11.3723 21.9898Z",
    fill: "#E22732"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.754 22.0263L29.7166 24.7625L24.5351 0.136566L11.754 22.0263Z",
    fill: "#E42934"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1449 22.0625L29.344 24.6805L24.5261 0.145452L12.1449 22.0625Z",
    fill: "#E62C36"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5356 22.0987L28.9711 24.5986L24.5168 0.154459L12.5356 22.0987Z",
    fill: "#E82E37"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9266 22.1262L28.5985 24.5169L24.5078 0.16371L12.9266 22.1262Z",
    fill: "#EA3039"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.308 22.1625L28.2163 24.4351L24.4984 0.181845L13.308 22.1625Z",
    fill: "#EC323A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M13.699 22.1989L27.8437 24.3533L24.4893 0.190974L13.699 22.1989Z",
    fill: "#EE343C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M14.09 22.235L27.4711 24.2713L24.4803 0.19986L14.09 22.235Z",
    fill: "#F0373E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4809 22.2716L27.0984 24.1896L24.4713 0.209109L14.4809 22.2716Z",
    fill: "#F3393F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8719 22.3078L26.7258 24.1077L24.4623 0.218117L14.8719 22.3078Z",
    fill: "#F53B41"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2628 22.3351L26.3531 24.026L24.4532 0.227245L15.2628 22.3351Z",
    fill: "#F73D43"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6448 22.3714L25.9806 23.9441L24.4443 0.236253L15.6448 22.3714Z",
    fill: "#F93F44"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0357 22.4077L25.5988 23.8622L24.4353 0.254389L16.0357 22.4077Z",
    fill: "#FB4246"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4262 22.4441L25.2257 23.7804L24.4257 0.263517L16.4262 22.4441Z",
    fill: "#FD4447"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8174 22.4804L24.8533 23.6985L24.417 0.272524L16.8174 22.4804Z",
    fill: "#FF4649"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M6.75406 21.4807L24.2986 23.6988L24.6531 0.0455217L6.75406 21.4807Z",
    fill: "url(#paint3_linear_1828_41)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1828_41",
    x1: 15.6993,
    y1: 38.4342,
    x2: 38.9435,
    y2: 38.4342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1828_41",
    x1: 15.6993,
    y1: 55.0334,
    x2: 38.9435,
    y2: 55.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1828_41",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.5846 23.9161) scale(21.0125 21.3261)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F67D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB623A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1828_41",
    x1: 6.79024,
    y1: 11.4133,
    x2: 24.9471,
    y2: 11.0573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FF4649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4649"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartsaNewIconMobile);
export default __webpack_public_path__ + "static/media/smartsa-new-icon-mobile.6b264895ce0a6d8500c5859c372e7cd8.svg";
export { ForwardRef as ReactComponent };